import { ErrorResponse, ServerError } from '~/infra/error-response/ErrorResponse';
export function getOtpErrorCause(error) {
    var _error_response, _error_response1;
    if (new ErrorResponse(error).hasServerError(ServerError.EmailAlreadyVerified)) {
        return 'emailAlreadyVerified';
    }
    if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 400) {
        return 'wrongCode';
    }
    if (((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status) === 429) {
        return 'tooManyRequests';
    }
    return 'unknown';
}
